const initialState = {
  logo: {
    principal: null,
    secondary: null,
    alt: 'Logo',
    map: null,
    footer: null,
    fifteenNavLogo: null,
    login: null,
  },
  colors: {
    principal: '',
    secondary: '',
    footer: '',
    text: '',
    button: {
      principal: '',
      principalHover: '',
      border: '',
      color: '',
    },
  },
  sliders: [],
  copyrights: '',
  siteInfo: {
    name: null,
    address: null,
    country: null,
    telephone: null,
    mail: null,
    id: null,
  },
  site_views: {
    dollar_view: true,
  },
};

const pageConfigurationReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PAGE_CONFIGURATION':
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default pageConfigurationReducer;
